import React from "react";
import { Navbar, Footer } from "./../../Components";
import Banner from "./../../Containers/Faq/Banner";
import ListFAQ from "./../../Containers/Faq/ListFAQ";
//import ForWish from "../../Containers/Faq/";
import {useLocation} from "react-router-dom";
import {useInfiniteQuery} from "react-query";
import api from "../../Services/api";
import DocumentMeta from 'react-document-meta';

function Faq() {
    const params = useLocation();
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [page, setPage] = React.useState(0);

    const meta = {
        title: ' Foire aux questions - Vignitus',
        description: 'Grâce à notre F.A.Q, apprenez comment acheter et vendre du vin sur la première plateforme de vente en ligne autour de l\'oenologie.',
        canonical: 'https://vignitus.fr/faq',
        meta: {
            charset: 'utf-8',
            name: {
                keywords: 'Vignitus,FAQ'
            }
        }
    };
    return (
        <DocumentMeta {...meta}>
        <div>
            <Navbar />
             <div className="content-wraper">
                <Banner />
                <ListFAQ/>
             </div>
             <Footer />
        </div>
        </DocumentMeta>
  );
}

export default Faq;
